import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import RequireAuth from "./AuthRouter";
import Container from "./Container";
import LoginPage from "../pages/LoginPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import NotFoundPage from "../pages/NotFoundPage";
import Dashboard from "../components/Dashboard";
import MyProfilePage from "../pages/MyProfilePage";
import SupportTable from "../components/tables/SupportTable";
import DocsTable from "../components/tables/DocsTable";
import UsersTable from "../components/tables/UsersTable";
import AdminCustomersTable from "../components/tables/AdminCustomersTable";
import AdminCustomerForm from "../components/forms/AdminCustomerForm";
import InvoicesTable from "../components/tables/InvoicesTable";
import AdminPaymentsTable from "../components/tables/AdminPaymentsTable";
import AdminUsersTable from "../components/tables/AdminUsersTable";
import FormPage from "../pages/FormPage";
import CRMPage from "../components/tables/CRMPage";
import FunnelManager from "../components/tables/FunnelManager";
import TasksTodayPage from "../pages/TasksTodayPage";
import TeamManagerPage from "../pages/TeamManagerPage";
import SignupPage from "../pages/SignUpPage";
import StageFormBuilder from "../components/crm/StageFormBuilder";
import FunnelPublicFormBuilder from "../components/crm/FunnelPublicFormBuilder";
import ActivityList from "../pages/ActivityList";
import FunnelsGallery from "../components/tables/FunnelGallery";
import FirstAccessOnboarding from "../pages/FirstAccessOnboarding";
import CardDetailsPage from "../pages/CardDetailsPage";
import ChatApp from "../pages/ChatApp";
import { SocketProvider } from "../contexts/SocketContext";
import GlobalChatDock from "../pages/GlobalChatDock";
import SalesInsightsPage from "../pages/SalesInsightsPage";
import CustomFieldsPage from "../pages/CustomFieldsPage";
import ReportsOverviewPage from "../pages/ReportsOverviewPage";
import LeadGeneratorPage from "../pages/LeadGeneratorPage";
import AutomationPage from "../pages/AutomationPage";
import BudgetGeneratorPage from "../pages/BudgetGeneratorPage";
import BudgetListPage from "../pages/BudgetListPage";
import ProductCatalogPage from "../pages/ProductCatalogPage";
import LeadCustomFieldsPage from "../pages/LeadCustomFieldsPage";
import GoogleCalendarCallbackPage from "../pages/GoogleCalendarCallbackPage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import ManageSubscriptionPage from "../pages/ManageSubscriptionPage";
import SubscriptionPaymentPage from "../pages/SubscriptionPaymentPage";
import CompaniesOverviewPage from "../pages/CompaniesOverviewPage";
import CompanyDetailPage from "../pages/CompanyDetailPage";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/form/:slug" element={<FormPage />} />
        <Route path="/politica-privacidade" element={<PrivacyPolicyPage />} />

        <Route
          path="/"
          element={
            <RequireAuth>
              <SocketProvider>
                <GlobalChatDock />
                <Container>
                  <Outlet />
                </Container>
              </SocketProvider>
            </RequireAuth>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<UsersTable />} />
          <Route path="crm" element={<CRMPage />} />
          <Route path="crm/tasks" element={<TasksTodayPage />} />
          <Route path="crm/automations" element={<AutomationPage />} />
          <Route path="budget" element={<BudgetGeneratorPage />} />
          <Route path="budgets" element={<BudgetListPage />} />
          <Route path="products" element={<ProductCatalogPage />} />
          <Route path="leads/generator" element={<LeadGeneratorPage />} />
          <Route path="funnels" element={<FunnelManager />} />
          <Route path="crm/fields" element={<CustomFieldsPage />} />
          <Route path="reports" element={<ReportsOverviewPage />} />
          <Route path="board" element={<FunnelsGallery />} />
          <Route path="teams" element={<TeamManagerPage />} />
          <Route path="invoices" element={<InvoicesTable />} />
          <Route path="activities" element={<ActivityList />} />
          <Route
            path="contacts/custom-fields"
            element={<LeadCustomFieldsPage />}
          />
          <Route
            path="/crm/stages/:stageId/form"
            element={<StageFormBuilder />}
          />
          <Route
            path="/crm/funnels/:funnelId/public-form"
            element={<FunnelPublicFormBuilder />}
          />
          <Route path="/crm/card/:id" element={<CardDetailsPage />} />
          <Route path="contacts" element={<AdminCustomersTable />} />
          <Route path="companies" element={<CompaniesOverviewPage />} />
          <Route path="companies/:companyId" element={<CompanyDetailPage />} />
          <Route path="admin/new-customer" element={<AdminCustomerForm />} />
          <Route path="admin/payments" element={<AdminPaymentsTable />} />
          <Route path="docs" element={<DocsTable />} />
          <Route path="chat" element={<ChatApp />} />
          <Route path="profile" element={<MyProfilePage />} />
          <Route path="assinatura" element={<ManageSubscriptionPage />} />
          <Route
            path="assinatura/pagamento"
            element={<SubscriptionPaymentPage />}
          />

          <Route path="support" element={<SupportTable />} />
          <Route path="insights" element={<SalesInsightsPage />} />
          <Route
            path="/integrations/google-calendar/callback"
            element={<GoogleCalendarCallbackPage />}
          />

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
